export enum WidgetProtectMode {
  // Anyone who can customize the dashboard may change the widget's options.
  UNPROTECTED = 'unprotected',
  // Nobody may change the widget's options until the mode is switched back.
  PROTECTED = 'protected',
  // Unlocked for the collaborator holding it (see `Widget.protectEditor`),
  // still protected for everybody else.
  EDIT = 'edit',
}
